import { useEffect, useRef, useState } from "react";
import { quotationAPI } from "../../api/quotationAPI";

export default function SalesRepTypeSearch({ salesRepCode, salesRepDesc, pCode }) {
    const [allSalesRep, setAllSalesRep] = useState([]);
    const isFirstRender = useRef(false);

    const getSalesRep = (searchKey = '') => {
        quotationAPI.getSalesRep(pCode, searchKey).then((data) => {
            setAllSalesRep(data);
        })
    }

    const handleRowSelect = (code, name) => {
        salesRepCode(code);
        salesRepDesc(name);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getSalesRep()
        }
    }, []);

    return (
        <>
            <div className="modal fade" id="salesRepTypeSearch" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Sales Rep</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <input type="text" className="form-control" placeholder="Search by code or name"
                                onChange={(e) => getSalesRep(e.target.value)}
                            />
                            <table className="table mt-1">
                                <thead className="thead--color">
                                    <tr>
                                        <th scope="col">Code</th>
                                        <th scope="col">Name</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allSalesRep && allSalesRep.map(data => (
                                        <tr key={data.repCode}>
                                            <td>{data.repCode}</td>
                                            <td>{data.repName}</td>
                                            <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                                onClick={() => handleRowSelect(data.repCode, data.repName)} data-bs-dismiss="modal">
                                                Select</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}